/* eslint-disable @next/next/no-img-element */
import { getTranslation } from "@/i18n/get-translation";
import ShareIcon from "@/icons/Share.svg";
import { IBlog } from "@/types/blog.type";
import { INews } from "@/types/news.type";
import Markdown from "react-markdown";
interface IContentSingle {
  locale: string;
  blog: IBlog | null;
  news: INews | null;
}

export default function ContentSingle({ locale, blog, news }: IContentSingle) {
  const t = getTranslation(locale, "contentSingle");

  return (
    <section className="w-full px-20 max-md:px-7 lg:pt-5 pt-4  ">
      {/* Blog Title */}
      {blog && (
        <h2 className="text-primary-800 font-medium xl:text-[3rem] lg:text-[2.5rem] md:text-[2.2rem] text-[1.88rem] leading-none relative mb-5">
          {blog.attributes.title}
        </h2>
      )}
      {news && (
        <h2 className="text-primary-800 font-medium xl:text-[3rem] lg:text-[2.5rem] md:text-[2.2rem] text-[1.88rem] leading-none relative mb-5">
          {news.attributes.title}
        </h2>
      )}
      {/* Blog Meta Data */}
      <div
        className="flex md:items-center items-start justify-start flex-wrap gap-[0.5rem] mb-6 xl:text-xl lg:text-lg   text-base font-light text-primary-800"
        aria-label="Global"
      >
        <div>
          {t("readTime")}{" "}
          {blog && (
            <span className="text-secondary-800 inline-block">
              {blog.attributes.readTime} {t("min")}
            </span>
          )}
          {news && (
            <span className="text-secondary-800 inline-block">
              {news.attributes.readTime} {t("min")}
            </span>
          )}
        </div>
        <span className="text-primary-400 font-bold">|</span>
        <div>
          {t("postedDate")}:{" "}
          {blog && (
            <span className="inline-block">
              {new Date(blog.attributes.publishedAt).toDateString()}
            </span>
          )}
          {news && (
            <span className="inline-block">
              {new Date(news.attributes.publishedAt).toDateString()}
            </span>
          )}
        </div>
        <span className="text-primary-400 font-bold">|</span>
        {blog &&
          blog.attributes?.blog_categories?.data &&
          blog.attributes?.blog_categories?.data.map((x) => (
            <div className="inline-flex gap-2" key={x.id}>
              <div>{x.attributes.name}</div>
              <span className="text-primary-400 font-bold">|</span>
            </div>
          ))}
        {news && news.attributes?.news_category?.data && (
          <>
            <div>{news.attributes?.news_category?.data?.attributes.name} </div>
            <span className="text-primary-400 font-bold">|</span>
          </>
        )}
        <div className="text-primary-800 flex items-center justify-start gap-[0.4rem]">
          <ShareIcon className="w-7" />
          {t("share")}
        </div>
      </div>
      <figure className="h-[42rem] rounded-lg overflow-hidden mb-16">
        {blog && (
          <img
            loading="lazy"
            className="w-full h-full object-cover xl:mb-16 lg:mb-12 md:mb-8 mb-6"
            src={`${
              blog?.attributes?.poster?.data
                ? blog?.attributes?.poster?.data?.attributes.url
                : "/images/clinic-image.webp"
            }`}
            alt="Feature image"
          />
        )}
        {news && (
          <img
            loading="lazy"
            className="w-full h-full object-cover xl:mb-16 lg:mb-12 md:mb-8 mb-6"
            src={`${
              news.attributes.poster.data
                ? news.attributes.poster.data?.attributes.url
                : "/images/clinic-image.webp"
            }`}
            alt="Feature image"
          />
        )}
      </figure>
      {blog && (
        <div className="prose max-w-full xl:text-xl lg:text-lg text-base text-primary-800 font-light   lg:px-40 px-0 lg:mb-10 mb-6">
          <Markdown>{blog.attributes.content}</Markdown>
        </div>
      )}
      {news && (
        <div className="prose max-w-full xl:text-xl lg:text-lg text-base text-primary-800 font-light   lg:px-40 px-0 lg:mb-10 mb-6">
          <Markdown>
            {news.attributes.content}
          </Markdown>
        </div>
      )}
    </section>
  );
}
